import Icon from 'src/components/atoms/icon'
import toast, { ToastBar, Toaster } from 'react-hot-toast'

function ToasterContainer() {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 5000,
        error: {
          duration: 10000,
        },
        success: {
          iconTheme: {
            primary: '#02b1a9',
            secondary: 'white',
          },
        },
      }}
    >
      {(t) => (
        <ToastBar toast={t}>
          {({ icon, message }) => (
            <>
              {icon}
              {message}
              {t.type !== 'loading' && (
                <button type="button" onClick={() => toast.dismiss(t.id)}>
                  <Icon name="X" className="text-bg-dark" />
                </button>
              )}
            </>
          )}
        </ToastBar>
      )}
    </Toaster>
  )
}

export default ToasterContainer
